var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-success",on:{"click":_vm.download}},[_vm._v(" Save Configuration ")])}
var staticRenderFns = []

export { render, staticRenderFns }